import { h, Component } from 'preact';
import IoLogo from '../../components/io_logo';
import SocialFooter from '../../components/social_footer';
import Footer from '../../components/footer';
import style from './style';

export default class Register extends Component {
	handleScroll() {
		const ele = document.querySelector('.topappbar.mdc-top-app-bar');
		if (document.documentElement.scrollTop < 56) {
			ele.setAttribute('top', true);
		}
		else {
			ele.removeAttribute('top');
		}
	}

	componentDidMount() {
		document.title = 'Code Of Conduct';
		window.addEventListener('scroll', this.handleScroll, { passive: true });
		this.handleScroll();
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		document.querySelector('.topappbar.mdc-top-app-bar').removeAttribute('top');
	}

	render({ rootPath }) {
		return (
			<div>
				<div class="hero">
					<IoLogo rootPath={rootPath} />
					<h2>Code of Conduct</h2>
				</div>
				<div class={style.container}>
					<p>GDG Korea Android 는 개발자 지향 커뮤니티 그룹으로서 권리 침해 없는 행사를 위하여 타인에게 불쾌감을 줄 수 있는 성 정체성, 성적 취향, 장애, 외모, 민족, 국적, 인종, 나이, 정치, 종교 등에 대한 발언은 금지합니다.</p>
					<p>행동강령은 Google Developers Group 행사에 참여하는 모든 개인에게 해당하며 위반 시 퇴장 등의 제재를 받을 수 있습니다. 행동강령 위반 사례에 대한 내용은 공개될 수 있습니다. </p>
					
					<h4>1. 사려 깊게 행동해주세요.</h4>
					<p><span>우리는 모두 같은 공동체의 구성원입니다. 그러므로 다른 사람들에게 친절하게 그리고 따듯하게 맞이하는 좋은 사람이 되어주세요. 다른 사람이 함께하고 싶어 하는 사람이 되어주세요.</span></p>
					<h4>2. 서로를 존중해 주세요.</h4>
					<p><span>활발한 토론은 건강한 개발자 생태계에 도움이 되지만, 비판이 아닌 비난은 해가 됩니다. 의견을 공감하려 노력하고, 갈등을 녹여가며 함께해주세요. 서로를 이해하기 위해 노력해주세요.</span></p>
					<h4>3. 말과 행동에 책임감을 보여주세요.</h4>
					<p><span>우리는 공동체의 구성원으로서 하는 말과 행동에 대해 책임이 있습니다. 그로 인해 문제가 발생한다면 바로잡아야 합니다. 어떠한 경우라도 말과 행동으로 인해 타인이 불쾌감을 느꼈다면 문제에 해당됩니다.</span></p>
					<h4>4. 적극적으로 참여해주세요.</h4>
					<p><span>적극적인 참여는 서로의 거리를 줄이고 보다 큰 가치를 만들어 냅니다. 적극적으로 참여하며 조화롭게 어울려주세요.</span></p>
					<h4>5. 자유롭게 도움을 구하세요.</h4>
					<p><span>곤란한 상황을 마주쳤다면 주위에 도움을 요청하세요. 그리고 도움을 요청받았다면 주저하지 말고 도와주세요.</span></p>
					<br />
					<p>건강한 공동체를 위해 구성원들은 위 행동강령을 준수하고, 주의 받은 구성원은 즉시 행동강령을 준수할 것을 요구합니다. 제재를 받은 경우 행사 참여를 위해 지불한 비용은 돌려받을 수 없습니다. 모든 구성원은 자신이나 다른 사람이 불편을 느끼게 하는 행동을 보았을 때 운영진을 찾거나 <a href="mailto:gdg.korea+coc@gmail.com">gdg.korea+coc@gmail.com</a>. 로 보내서 알려야 합니다. 운영진은 이를 인지했을 때 즉시 행동을 취해야 합니다.</p>
					<br />
					<p>운영진은 참가자에게 흔쾌히 도움을 주어야 하며 참가자의 안전을 지키기 위한 노력을 해야합니다. 그 노력에는 참가자 보호, 경찰/사법기관으로의 연락을 포함합니다.</p>
			
				</div>
				<SocialFooter rootPath={rootPath} />
				<Footer rootPath={rootPath} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./routes/coc/index.js